<template>
    <Default-Layout>
        <div class="container profile">
            <div class="row">
                <div class="col-6 offset-md-3">
                    <div class="prof_title">
                        <h4>{{ $t("lang.label_bling_inf") }}</h4>
                        <p>{{ $t("lang.label_manage_bling_dtls") }}</p>
                    </div>
                    <div class="card" style="border-top: 4px solid #a1e0ae">
                        <div class="icontri"></div>
                        <div class="card-body">
                            <form @submit.prevent="editProfile">
                                <div class="form-row">
                                    <div class="form-group col-md-12">
                                        <label for="">{{
                                            $t("lang.label_name_org")
                                        }}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="p.bill_company_name"
                                        />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="">{{ $t("lang.label_fname") }}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="p.bill_firstname"
                                        />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="">{{ $t("lang.label_lname") }}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="p.bill_lastname"
                                        />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="">{{ $t("lang.label_adress") }}</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="p.bill_address"
                                    />
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="inputCity">{{
                                            $t("lang.label_city")
                                        }}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="p.bill_city"
                                        />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="inputCity">{{
                                            $t("lang.label_state")
                                        }}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="p.bill_state"
                                        />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="">{{ $t("lang.label_zip") }}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="p.bill_zip_code"
                                        />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="">{{
                                            $t("lang.label_telephone")
                                        }}</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="p.bill_telephone"
                                        />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="">{{ $t("lang.label_website") }}</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="p.bill_website"
                                    />
                                </div>
                                <button type="submit" class="btn btn-primary float-right">
                                    {{ $t("lang.label_up") }}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Default-Layout>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import DefaultLayout from "@/Layouts/Account/DefaultLayout";
export default {
    name: "Profile",
    components: {
        DefaultLayout,
    },
    data () {
        return {
            p: {
                user_id: window.localAccountID,
                bill_company_name: "",
                bill_firstname: "",
                bill_lastname: "",
                bill_address: "",
                bill_city: "",
                bill_state: "",
                bill_zip_code: "",
                bill_telephone: "",
                bill_website: "",
            },
        }
    },
    created () {
        if (window.user_type == 2) {
            this.$router.push({ name: "Home" });
        }
        this.getProfile();
    },
    methods: {
        getProfile() {
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + window.localtoken_M;
            axios
                .get(window.urlmaster + "api/v3/billinginfo/" + window.localAccountID)
                .then((response) => {
                    let e = response.data.result;
                    if (e != null) {
                        this.p = e;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + window.localtoken;
        },
        editProfile() {
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + window.localtoken_M;
            axios
                .post(window.urlmaster + "api/v3/editbillinginfo", this.p)
                .then((response) => {
                    console.log(response.data);
                    this.$swal.fire({
                        type: "success",
                        title: window.lang2.msj_up_prof_sful,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.$swal.fire({
                        type: "error",
                        title: window.lang2.msj_err_upting_data,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                });
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + window.localtoken;
        },
    },
}
</script>

<style>
.icontri {
    position: absolute;
    top: -21px;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid #a1e0ae;
    transform: translateX(-50%);
}
.prof_title {
    display: block;
    font-size: 14px;
}
.prof_title h4 {
    font-weight: 100;
    font-size: 24px;
    text-align: center;
}
.profile {
    margin-top: 60px;
}
.profile label {
    display: block;
    margin-bottom: 0.1rem;
}
</style>
